<template>
   <div class="crud-wrapper">
      <crud :form-component="CampaignForm" :grid-columns="gridColumns" :grid-options="gridOptions"
            obj="campaign" ref="crud">
      </crud>
   </div>
</template>

<script>

   import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';
   import CampaignForm from './CampaignForm';

   export default PageClass.extend({
      name: 'Campaigns',

      data () {
         return {
            CampaignForm,

            gridColumns: [
               {
                  dataField: 'storeName',
                  caption: 'Empresa',
                  minWidth: 150,
                  groupIndex: 0
               },
               {
                  dataField: 'covenantName',
                  caption: 'Convênio',
                  width: 120
               },
               {
                  dataField: 'name',
                  caption: 'Campanha',
                  minWidth: 150
               },
               {
                  dataField: 'queueName',
                  caption: 'Fila',
                  minWidth: 120,
                  visible: false
               },
               {
                  dataField: 'statusName',
                  caption: 'Situação',
                  width: 120
               },
               {
                  caption: 'Contatos',
                  alignment: 'center',
                  columns: [
                     {
                        dataField: 'names_qty',
                        caption: 'Total',
                        dataType: 'number',
                        format: {
                           type: 'fixedPoint',
                           precision: 0
                        },
                        width: 110
                     },
                     {
                        dataField: 'processedPercent',
                        caption: '% Processado',
                        dataType: 'number',
                        format: {
                           type: 'percent',
                           precision: 1
                        },
                        width: 110
                     },
                     {
                        dataField: 'reachedPercent',
                        caption: '% Alcançado',
                        dataType: 'number',
                        format: {
                           type: 'percent',
                           precision: 1
                        },
                        width: 110
                     },
                     {
                        dataField: 'successPercent',
                        caption: '% Negócios',
                        dataType: 'number',
                        format: {
                           type: 'percent',
                           precision: 1
                        },
                        width: 110
                     },
                     {
                        dataField: 'names_tried',
                        caption: 'Processados',
                        dataType: 'number',
                        format: {
                           type: 'fixedPoint',
                           precision: 0
                        },
                        width: 100,
                        visible: false
                     },
                     {
                        dataField: 'names_reached',
                        caption: 'Alcançados',
                        dataType: 'number',
                        format: {
                           type: 'fixedPoint',
                           precision: 0
                        },
                        width: 100,
                        visible: false
                     },
                     {
                        dataField: 'names_deals',
                        caption: 'Negócios',
                        dataType: 'number',
                        format: {
                           type: 'fixedPoint',
                           precision: 0
                        },
                        width: 90,
                        visible: false
                     }
                  ]
               },
               {
                  name: 'command',
                  width: 90,
                  alignment: 'left',
                  cellTemplate: (element, info) => {
                     if (info.data.commands) {
                        let fab = info.data.commands;

                        for (let i = 0; i < fab.length; i++) {
                           let btn = fab[i];
                           let fabId = 'fabId_' + info.data.id + '_' + i;
                           let data = Object.assign({}, info.data, {
                              rowIndex: info.rowIndex,
                              grid: info.component,
                              cmd: fab[i].cmd
                           });

                           $(`<i id="${fabId}" class='material-icons btn-grid-command'>${btn.icon}</i>`).on('dxclick', data, this.fabCommand).appendTo(element);
                           setTimeout(() => {
                              $(`<span>${btn.hint}</span>`).dxTooltip({
                                 width: 110,
                                 position: 'top',
                                 target: '#' + fabId,
                                 showEvent: 'mouseenter',
                                 hideEvent: 'mouseleave'
                              }).appendTo(element);
                           }, 100);
                        }
                     }
                  }
               }
            ],

            gridOptions: {
               onRowPrepared: (info) => {
                  if (info.rowType === 'data') {
                     info.rowElement.addClass(info.data.statusColor);
                  }
               }
            }

         };

      },

      methods: {
         dataRequestDone () {
            this.$refs.crud.refreshGrid();
         },

         async fabCommand (evt) {
            evt.stopPropagation();
            let cmd = evt.data.cmd;

            switch (cmd) {
               case 'import':
                  window.getApp.showModal('CampaignDataImport',
                     {
                        props: { campaign: evt.data },
                        modalWidth: 600,
                        doneCallback: this.dataRequestDone
                     }
                  );
                  break;
               case 'askData':
                  window.getApp.showModal('CampaignDataFilter',
                     {
                        props: { campaign: evt.data },
                        modalWidth: 600,
                        doneCallback: this.dataRequestDone
                     }
                  );
                  break;
               default:
                  let params = {
                     cmd,
                     statusId: evt.data.statusId
                  };
                  let res = await this.$api.dataService.execute('campaign/statusChangeCmd', params, evt.data.id);
                  if (res) {
                     this.$refs.crud.refreshGrid();
                     if (res.statusId === 60) {
                        this.$notifyUser({
                           type: 'success',
                           message: `Nova Campanha ${'RP: ' + res.name} gerada com sucesso.`
                        });
                     } else {
                        this.$notifyUser({
                           type: 'success',
                           message: `Situação de ${res.name} alterada com sucesso.`
                        });
                     }
                  }
            }

         }

      },

   });

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Campaigns.vue